import { formatFromDate } from "src/app/common/datetime_utility";
import { ViolationAudit, ViolationNote } from "src/app/models/api/violations.model";
import { ITimelineItem } from "../../components/timeline/timeline.component";

export interface INoteCardInput {
    id: string;
    addedBy: string;
    addedAt: string;
    content: string;
}

export const toNoteCardInput = (note: ViolationNote): INoteCardInput =>
    ({
        id: note.id,
        content: note.content,
        addedBy: note.addedBy,
        addedAt: formatFromDate(note.addedAt),
    }) as INoteCardInput;

export const noteCardInputDescending = (a: INoteCardInput, b: INoteCardInput) => new Date(b.addedAt).getTime() - new Date(a.addedAt).getTime();

export interface IAuditCardInput {
    id: string;
    userIdentity: string;
    eventTime: string;
    message: string;
}

export const toAuditCardInput = (audit: ViolationAudit): ITimelineItem =>
    ({
        text: audit.userIdentity + "  " + formatFromDate(audit.eventTime),
        secondaryText: audit.message,
        iconPath: "assets/images/common/seen.svg",
    }) as ITimelineItem;
